export enum adminInvoicePostTypes {
    FETCH_ADMIN_INVOICE_POST_REQUEST = "FETCH_ADMIN_INVOICE_POST_REQUEST",
    FETCH_ADMIN_INVOICE_POST_SUCCESS = "FETCH_ADMIN_INVOICE_POST_SUCCESS",
    FETCH_ADMIN_INVOICE_POST_FAILURE = "FETCH_ADMIN_INVOICE_POST_FAILURE",
  }